<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{params.title}}</div>
    <div slot="body">
      <dialog-selected-tips :name="params.name" :count="params.data.length" :action="params.title" />
      <dialog-table class="mb-2" :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('op_69')" v-bind="formItemLayout">
            <a-input-number
              v-if="params.rateData.rate_type === 'amount'"
              class="w-100"
              v-decorator="decorators.rate"
              :formatter="value => `${currencySign} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="value => value.replace(/\$\s?|(,*)/g, '')" />
            <a-input-number
              v-else
              class="w-100"
              v-decorator="decorators.rate"
              :min="1"
              :max="100"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')" />
        </a-form-item>
        <a-form-item :label="$t('op_79')" v-bind="formItemLayout">
          <a-radio-group name="enabledRadioGroup" v-decorator="decorators.enabled">
            <a-radio :value="true">{{$t('op_80')}}</a-radio>
            <a-radio :value="false">{{$t('op_81')}}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="$t('op_82')" v-bind="formItemLayout">
          <a-radio-group name="endedRadioGroup" v-decorator="decorators.ended">
            <a-radio :value="true">{{$t('op_80')}}</a-radio>
            <a-radio :value="false">{{$t('op_81')}}</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'UpdateSkuRateHistoryDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        rate: [
          'rate',
          {
            initialValue: 1,
            rules: [
              { required: true, message: this.$t('op_77') },
            ],
          },
        ],
        enabled: [
          'enabled',
          {
            initialValue: this.params.data[0].enabled,
          },
        ],
        ended: [
          'ended',
          {
            initialValue: this.params.data[0].ended,
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
    currencySign () {
      return this.params.data[0].currency === 'USD' ? '$' : '￥'
    },
  },
  methods: {
    doCreate (data) {
      return this.params.onManager('update', {
        id: this.params.data[0].id,
        managerArgs: {
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doCreate(values)
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
